import { URL_ENDPOINT } from 'src/utils/constants/service';
import {
  BookmarkTypes,
  IBookmarkCompanyCreatePayload,
  IBookmarkCompareCreatePayload,
  IBookmarkCreateResponse,
  IBookmarkModelAndTypeMapping,
  IBookmarkModelAndTypeMappingRaw,
  IBookmarkPeopleCreatePayload,
  IBookmarkTradeDataCreatePayload,
} from 'src/model/bookmark';
import { deleteRequest, getRequest, postRequest, putRequest } from 'src/services/api/http';
import { CommonResponse, CommonResponseList } from 'src/model/common';

const BookmarkService = {
  getBookmarks,
  getBookmarkByDataUuid,
  createBookmark,
  deleteBookmark,
  putBookmark,
  updateBookmarkByDataUuid,
  deleteBookmarkData,
  getBookmarkDataUuid,
};

export default BookmarkService;

function getBookmarks<T extends BookmarkTypes>(type: T, query: any) {
  const url = URL_ENDPOINT.bookmark.list.replace(':type', type);
  return getRequest(url, query, new CommonResponseList()) as Promise<IResponseList<IBookmarkModelAndTypeMappingRaw[T]>>;
}

function getBookmarkByDataUuid<T extends BookmarkTypes>(type: T, dataUuid: string) {
  const url = URL_ENDPOINT.bookmark.detailData.replace(':type', type).replace(':data_uuid', dataUuid);
  return getRequest(url, {}, new CommonResponse()) as Promise<IResponse<IBookmarkModelAndTypeMappingRaw[T]>>;
}

function createBookmark(
  type: BookmarkTypes,
  body:
    | IBookmarkCompanyCreatePayload
    | IBookmarkPeopleCreatePayload
    | IBookmarkTradeDataCreatePayload
    | IBookmarkCompareCreatePayload,
) {
  const url = URL_ENDPOINT.bookmark.list.replace(':type', type);
  return postRequest(url, body) as Promise<CommonResponse>;
}

function deleteBookmark(type: BookmarkTypes, bookmarkId: string) {
  const url = URL_ENDPOINT.bookmark.detailBookmark.replace(':type', type).replace(':id', bookmarkId);
  return deleteRequest(url) as Promise<CommonResponse>;
}

function putBookmark(type: BookmarkTypes, bookmarkId: string, body?: { note?: string }) {
  const url = URL_ENDPOINT.bookmark.detailBookmark.replace(':type', type).replace(':id', bookmarkId);
  return putRequest(url, body) as Promise<CommonResponse>;
}

function updateBookmarkByDataUuid(type: BookmarkTypes, dataUuid: string, body?: { note?: string }) {
  const url = URL_ENDPOINT.bookmark.detailData.replace(':type', type).replace(':data_uuid', dataUuid);
  return putRequest(url, body) as Promise<CommonResponse>;
}

function deleteBookmarkData(type: BookmarkTypes, bookmarkId: string) {
  const url = URL_ENDPOINT.bookmark.detailData.replace(':type', type).replace(':data_uuid', bookmarkId);
  return deleteRequest(url) as Promise<CommonResponse>;
}

function getBookmarkDataUuid(body: IBookmarkTradeDataCreatePayload | IBookmarkCompareCreatePayload) {
  const url = URL_ENDPOINT.bookmark.dataUuid;
  return postRequest(url, body) as Promise<CommonResponse>;
}
